export class Model {
    constructor(
        public id?: number,
        public name?: string,
        public serilNumerShortcut?: string,
        public dpi?: number,
        public screenHeight?: number,
        public screenWidth?: number,
        public shutdownAnimationDescFile?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model/model.model.ts